(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD' }).format(cents / 100);
  const init = (root = document) => {
    root.querySelectorAll('[data-kaliva-hero]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const data = hero.querySelector('[data-variants]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const sellingPlanGroupsData = hero.querySelector('[data-selling-plan-groups]');
      const sellingPlanGroups = sellingPlanGroupsData ? JSON.parse(sellingPlanGroupsData.textContent) : [];
      const input = hero.querySelector('[data-variant-input]');
      const price = hero.querySelector('[data-price]');
      const compare = hero.querySelector('[data-compare]');
      const availability = hero.querySelector('[data-availability]');
      const stock = hero.querySelector('[data-stock]');
      const button = hero.querySelector('[type=submit]');
      const media = hero.querySelector('[data-main-media]');
      const refill = hero.querySelector('[data-refill-toggle]');
      const sellingPlan = hero.querySelector('[data-selling-plan-input]');
      const refillFrequency = hero.querySelector('[data-refill-frequency]');
      const refillPlan = hero.querySelector('[data-refill-plan]');
      const choices = [...hero.querySelectorAll('[data-variant-choice]')];
      const planPrice = (choice, planId) => {
        const match = (choice?.dataset.subscriptionPrices || '').split('|').map((entry) => entry.split('=')).find(([id]) => id === String(planId));
        return Number(match?.[1]);
      };
      const planGroupFor = (choice) => sellingPlanGroups.find((group) => group.plans.some((plan) => Number.isFinite(planPrice(choice, plan.id))));
      let activePlanGroupId = sellingPlanGroups.find((group) => group.plans.some((plan) => String(plan.id) === String(sellingPlan?.value)))?.id || '';
      const syncPlanOptions = (group) => {
        if (!refillPlan || !group || activePlanGroupId === group.id) return;
        refillPlan.replaceChildren();
        group.plans.forEach((plan) => {
          const option = document.createElement('option');
          option.value = plan.id;
          option.textContent = plan.name;
          refillPlan.append(option);
        });
        refillPlan.value = group.plans[0]?.id || '';
        activePlanGroupId = group.id;
      };
      const update = () => {
        const choice = choices.find((item) => item.checked) || choices[0];
        const variant = variants.find((item) => String(item.id) === choice?.value);
        if (!variant) return;
        input.value = variant.id;
        const selectedPlanGroup = planGroupFor(choice);
        syncPlanOptions(selectedPlanGroup);
        if (refill) {
          refill.disabled = !selectedPlanGroup;
          if (!selectedPlanGroup) refill.checked = false;
        }
        const planId = refillPlan?.value || sellingPlan?.value;
        const refillPrice = planPrice(choice, planId);
        const subscriptionActive = Boolean(refill?.checked && planId && Number.isFinite(refillPrice));
        if (sellingPlan) { sellingPlan.value = planId || ''; sellingPlan.disabled = !subscriptionActive; }
        if (refillFrequency) refillFrequency.hidden = !refill?.checked;
        if (price) price.textContent = money(subscriptionActive ? refillPrice : variant.price);
        if (compare) { const comparePrice = subscriptionActive ? variant.price : variant.compare_at_price; compare.hidden = !comparePrice; compare.textContent = comparePrice ? money(comparePrice) : ''; }
        availability.textContent = variant.available ? 'Available' : 'Sold out';
        stock.hidden = !variant.available;
        button.disabled = !variant.available;
        hero.querySelectorAll('[data-variant-card]').forEach((card) => {
          const cardChoice = card.querySelector('[data-variant-choice]');
          const cardVariant = variants.find((item) => String(item.id) === cardChoice?.value);
          const cardPlanId = cardChoice === choice ? planId : planGroupFor(cardChoice)?.plans[0]?.id;
          const cardRefillPrice = planPrice(cardChoice, cardPlanId);
          const cardSubscriptionActive = Boolean(refill?.checked && Number.isFinite(cardRefillPrice));
          const currentPrice = card.querySelector('[data-card-current-price]');
          const regularPrice = card.querySelector('[data-card-regular-price]');
          const compareAt = card.querySelector('[data-card-compare-at]');
          if (currentPrice && cardVariant) currentPrice.textContent = money(cardSubscriptionActive ? cardRefillPrice : cardVariant.price);
          if (regularPrice) { regularPrice.hidden = !cardSubscriptionActive; regularPrice.textContent = cardSubscriptionActive && cardVariant ? money(cardVariant.price) : ''; }
          if (compareAt) compareAt.hidden = cardSubscriptionActive;
          card.classList.toggle('is-selected', cardChoice === choice);
        });
        if (variant.featured_media?.preview_image?.src && media) media.src = variant.featured_media.preview_image.src;
      };
      choices.forEach((choice) => choice.addEventListener('change', update));
      refill?.addEventListener('change', update);
      refillPlan?.addEventListener('change', update);
      const alignClaimPanel = () => {
        const claim = hero.querySelector('[data-claim-panel]');
        if (!claim) return;
        button.style.marginTop = '0px';
        claim.style.marginTop = '16px';
        if (window.matchMedia('(min-width: 750px)').matches) {
          const targetBottom = button.getBoundingClientRect().bottom;
          const claimBottom = claim.getBoundingClientRect().bottom;
          if (claimBottom > targetBottom) {
            button.style.marginTop = `${claimBottom - targetBottom}px`;
          } else {
            claim.style.marginTop = `${16 + targetBottom - claimBottom}px`;
          }
        }
      };
      requestAnimationFrame(alignClaimPanel);
      window.addEventListener('resize', alignClaimPanel);
      hero.querySelectorAll('[data-thumb-src]').forEach((thumbnail) => thumbnail.addEventListener('click', () => { if (media) media.src = thumbnail.dataset.thumbSrc; hero.querySelectorAll('[data-thumb-src]').forEach((item) => item.setAttribute('aria-current', 'false')); thumbnail.setAttribute('aria-current', 'true'); }));
      hero.querySelector('form')?.addEventListener('submit', () => { if (!button.disabled) { button.disabled = true; button.textContent = 'Adding…'; } });
      update();
    });
    root.querySelectorAll('[data-kaliva-tabs]').forEach((element) => { if (element.dataset.ready) return; element.dataset.ready = 'true'; const tabs = [...element.querySelectorAll('.kaliva-tabs__list [role="tab"]')]; const panels = [...element.querySelectorAll('[role="tabpanel"]')]; tabs.forEach((tab, index) => tab.addEventListener('click', () => { tabs.forEach((item, position) => { const active = position === index; item.setAttribute('aria-selected', active); panels[position].hidden = !active; }); })); });
    root.querySelectorAll('[data-kaliva-timeline]').forEach((element) => { if (element.dataset.ready) return; element.dataset.ready = 'true'; const buttons = [...element.querySelectorAll('[data-stage]')]; const panels = [...element.querySelectorAll('[data-stage-panel]')]; buttons.forEach((button, index) => button.addEventListener('click', () => { buttons.forEach((item, position) => item.setAttribute('aria-current', position === index)); panels.forEach((panel, position) => panel.hidden = position !== index); })); });
    root.querySelectorAll('[data-kaliva-date]').forEach((element) => { const date = new Date(); date.setDate(date.getDate() + Number(element.dataset.kalivaDate || 2)); element.textContent = date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); });
    root.querySelectorAll('[data-kaliva-header]').forEach((element) => {
      if (element.dataset.ready) return;
      element.dataset.ready = 'true';
      const menuButton = element.querySelector('[data-menu-button]');
      const setMenuOpen = (isOpen) => {
        element.dataset.open = String(isOpen);
        menuButton?.setAttribute('aria-expanded', String(isOpen));
        document.body.classList.toggle('kaliva-menu-open', isOpen);
      };
      menuButton?.addEventListener('click', () => setMenuOpen(element.dataset.open !== 'true'));
      element.querySelectorAll('[data-menu-close], .kaliva-header__drawer-nav a').forEach((item) => item.addEventListener('click', () => setMenuOpen(false)));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenuOpen(false); });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
